/**
 * Narxni o'zbek tilidagi formatga o'tkazadi.
 * Misol: 150000 → "150 000 so'm"
 */
export function formatPrice(price: number): string {
  return price.toLocaleString('uz-UZ') + " so'm";
}
